(function (angular, app) {
   "use strict";

   // Slider
   angular.module(app.modules.outing.name)
      .directive(app.modules.outing.directives.playerpicker, PlayerPickerDirective);

   PlayerPickerDirective.$inject = ["$timeout", "$q", "ngDialog"
      , app.modules.common.services.functions
      , app.modules.common.services.storage
      , app.modules.common.constants.appmessaging
      , app.modules.member.services.search
      , app.modules.common.constants.appsettings
   ];

   function PlayerPickerDirective($timeout, $q, ngDialog
       , ggFunctions
       , ggStorage
       , ggMessaging
       , ggOutingsSvc
       , appSettings
       ) {

      var ctrl = this;

      return {
         restrict: "A"
         , templateUrl: "app/outing/directives/playerpicker.html"
         , scope: {
            callback: "&"
         }
         , link: function (scope, element, attrs) {

            var isUpdateView = true;

            scope.pp = {
               view: {
                  tabs: {
                     current: 1
                     , types: {
                        player: 1
                        , team: 2
                     }
                     , isActive: function (tab) {
                        return scope.pp.view.tabs.current == tab;
                     }
                     , select: function (tab) {
                        if (!tab) {
                           tab = scope.pp.view.tabs.current;
                        }

                        if (scope.pp.isTeamPick) {
                           tab = scope.pp.view.tabs.types.team;
                        }

                        // Reset selected
                        scope.pp.dialog.content.player.selected = [];
                        scope.pp.dialog.content.team.selected = [];
                        scope.pp.dialog.selected = [];
                        
                        scope.pp.view.tabs.current = tab;
                        scope.pp.isError = false;
                        scope.pp.msg = "There were no players/teams found.";
                     }
                  }
               }
               , window: ggFunctions.fetchWindowSize()
               , buttonText: "Choose Players"
               , buttonClass : "btn-primary"
               , outingId: 0
               , parentId: 0
               , pickTo : "TeeTime"
               , isTeamPick : false
               , isLoaded: false
               , isError: false
               , isNextAction : false

               , dialog: {
                  alert: ""
                  , isProcessing: false
                  , selected: []
                  , results: []
                  , content: {
                     results: []
                     , player: {
                        isSearch: false
                        , results: []
                        , selected: []
                        , isSelected: function (id) {
                           var rv = -1;
                           for (var v = 0; v < scope.pp.dialog.content.player.selected.length; v++) {
                              if (scope.pp.dialog.content.player.selected[v].id == id) {
                                 rv = v;
                                 break;
                              }
                           }

                           return rv;
                        }
                        , toggle: function (obj) {
                           var v = scope.pp.dialog.content.player.isSelected(obj.id)
                           if (v > -1) {
                              scope.pp.dialog.content.player.selected.splice(v, 1);
                           } else {
                              scope.pp.dialog.content.player.selected.push(obj);
                           }
                           scope.pp.dialog.selected = scope.pp.dialog.content.player.selected;
                        }
                     }
                     , team: {
                        isSearch: false
                        , results: []
                        , selected: []
                        , isSelected: function (id) {
                           var rv = -1;
                           for (var v = 0; v < scope.pp.dialog.content.team.selected.length; v++) {
                              if (scope.pp.dialog.content.team.selected[v].id == id) {
                                 rv = v;
                                 break;
                              }
                           }
                           return rv;
                        }
                        , toggle: function (obj) {
                           var v = scope.pp.dialog.content.team.isSelected(obj.id)
                           if (v > -1) {
                              scope.pp.dialog.content.team.selected.splice(v, 1);
                           } else {
                              scope.pp.dialog.content.team.selected.push(obj);
                           }
                           scope.pp.dialog.selected = scope.pp.dialog.content.team.selected;
                        }
                     }

                  }

               }
               , f: {
                  pickPlayer: function () {
                     ngDialog.closeAll();


                     app.Member.Session.pageTemplates.fetch("app/outing/directives/playerpicker-modal.html").then(function (template) {
                        if (isCordova && isCordovaReady) {
                           StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                        }

                        var _playerPicker = ngDialog.open({
                           template: template
                           , plain: true
                           , closeByEscape: false
                           , closeByDocument: false
                           , showClose: false
                           , className: "slideup picker player"
                           , scope: scope
                        });

                        _playerPicker.closePromise.then(function () {
                           if (isCordova && isCordovaReady) {
                              StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                           }

                           var results = [];
                           var data = {};
                           if (scope.pp.view.tabs.current == 1) {
                              results = scope.pp.dialog.content.player.selected;
                              data = {
                                 parentId: scope.pp.parentId
                                 , players: results
                                 , isNextAction: scope.pp.isNextAction
                              }
                           }
                           if (scope.pp.view.tabs.current == 2) {
                              results = scope.pp.dialog.content.team.selected;
                              data = {
                                 parentId: scope.pp.parentId
                                 , teams: results
                                 , isNextAction: scope.pp.isNextAction
                              }
                           }


                           scope.callback()(data);

                        });
                     });


                     var root = scope.$rootScope
                     // WHy so many prents?

                     var thisRootScope = null;
                     var isTeamPicker = false;
                     var isTeeTimePicker = false;
                     var isGamePicker = false;

                     // Pick To's
                     if (scope.pp.pickTo == "TeeTime" && scope.$parent.$parent.$parent.$parent.Outing) {
                        thisRootScope = scope.$parent.$parent;
                        isTeeTimePicker = true;
                     }

                     if (scope.pp.pickTo == "Team") {
                        thisRootScope = scope.$parent;
                        isTeamPicker = true;
                     }

                     if (scope.pp.pickTo == "Game") {
                        thisRootScope = scope;
                        isGamePicker = true;
                     }


                     if (thisRootScope) {


                        var Outing  = thisRootScope.$parent.$parent.Outing;
                        var Round   = thisRootScope.$parent.Round;

                        // All available players
                        if (!scope.pp.isTeamPick) {
                           scope.pp.dialog.content.player.results = angular.copy(Outing.players);
                           scope.pp.dialog.content.player.results.isSearch = true;
                        } else {
                           scope.pp.dialog.content.team.results = angular.copy(Outing.teams);
                           scope.pp.dialog.content.team.results.isSearch = true;
                        }

                        var removePlayer = function (playerId) {
                           for (var r = 0; r < scope.pp.dialog.content.player.results.length; r++) {
                              if (playerId == scope.pp.dialog.content.player.results[r].id) {
                                 scope.pp.dialog.content.player.results.splice(r, 1);
                                 break;
                              }
                           }
                        }

                        // Remove Players we can't select
                        if (isTeeTimePicker) {
                           for (var t = 0; t < Round.teeTimes.length; t++) {
                              var tt = Round.teeTimes[t];
                              for (var p = 0; p < tt.players.length; p++) {
                                 removePlayer(tt.players[p].id);
                              }
                           }
                        }

                        if (isTeamPicker) {
                           for (var t = 0; t < Outing.teams.length; t++) {
                              var tt = Outing.teams[t];
                              for (var p = 0; p < tt.players.length; p++) {
                                 removePlayer(tt.players[p].id);
                              }
                           }
                        }
                        if (isGamePicker) {
                           for (var t = 0; t < Outing.games.length; t++) {
                              var tt = Outing.games[t];

                              if (tt.id == scope.pp.parentId) {
                                 for (var p = 0; p < tt.players.length; p++) {
                                    removePlayer(tt.players[p].id);
                                 }
                              }
                           }
                        }

                        if (scope.pp.dialog.content.player.results.length == 0) {
                           scope.pp.dialog.alert = "There are no available players to choose from.  You should invite more players to the outing.";
                           scope.pp.isError = true;
                        }
                        

                     }


                     scope.pp.view.tabs.select();
                  }
                  , sendInvite : function(){
                     scope.pp.isNextAction = true;
                     ngDialog.closeAll();

                  }
               }
            }

            var loadOptions = function (objStr, isUpdate) {
               if (objStr) {
                  var obj = JSON.parse(objStr);
                  if (obj) {

                     // Default View
                     if (obj.defaultView) {
                        scope.pp.view.tabs.current = Number(obj.defaultView);
                     }

                     if (obj.buttonText) {
                        scope.pp.buttonText = obj.buttonText;
                     }
                     if (obj.buttonClass) {
                        scope.pp.buttonClass = obj.buttonClass;
                     }

                     if (obj.outingId) {
                        scope.pp.outingId = Number(obj.outingId);
                     }

                     if (obj.parentId && obj.parentId != 0) {
                        scope.pp.parentId = Number(obj.parentId);
                     }

                     if (obj.pickType && obj.pickType == "Team") {
                        scope.pp.isTeamPick = true;
                     }

                     if (obj.pickTo) {
                        scope.pp.pickTo = obj.pickTo;
                     }

                  }
               }
            }

            ////////////////////////////////////////
            // Watch for Change in Options
            attrs.$observe('options', function () {
               var optStr = attrs.options;
               if (optStr != "") {
                  loadOptions(optStr, true);
               }
            });
         }
      }
   }
}(angular, app));
